<template>
    <IntegrationStoreSettingsLayout @save="saveAndContinue" @cancel="preventLeavingWithUnsavedChanges">
        <div class="form-group">
            <label class="font-weight-bold">Warehouse-ID</label>
            <select class="form-control" v-model="storeConfig.zoho_warehouse_id">
                <option :selected="storeConfig.zoho_warehouse_id === null" disabled>
                    {{ __('actions.please_select') }}
                </option>
                <option v-for="(warehouseName, warehouseId) in formData.warehouses"
                        :key="warehouseId"
                        :value="warehouseId"
                        :selected="storeConfig.zoho_warehouse_id === warehouseId"
                >
                    [{{ warehouseId }}] {{ warehouseName }}
                </option>
            </select>
            <span class="form-text text-muted">
                {{ __('integrations.select_warehouse') }}
            </span>
        </div>
        <div class="form-group">
            <label class="font-weight-bold">Bank Account-ID</label>
            <select class="form-control" v-model="storeConfig.zoho_bank_account_id">
                <option :selected="storeConfig.zoho_bank_account_id === null" disabled>
                    {{ __('actions.please_select') }}
                </option>
                <option v-for="(bankAccountName, bankAccountId) in formData.bank_accounts"
                        :key="bankAccountId"
                        :value="bankAccountId"
                        :selected="storeConfig.zoho_bank_account_id === bankAccountId"
                >
                    [{{ bankAccountId }}] {{ bankAccountName }}
                </option>
            </select>
            <span class="form-text text-muted">
                {{ __('integrations.select_bank_account') }}
            </span>
        </div>
    </IntegrationStoreSettingsLayout>
</template>

<script>
import Errors from "@components/Errors.vue";
import IntegrationStoreSettingsLayout from "@layouts/IntegrationStoreSettingsLayout.vue";
import IntegrationStoreConfigMixin from "@mixins/IntegrationStoreConfigMixin";

export default {
    components: {IntegrationStoreSettingsLayout, Errors},

    mixins: [IntegrationStoreConfigMixin],

    data() {
        return {
            storeConfig: {
                zoho_warehouse_id: null,
                zoho_bank_account_id: null,
            }
        }
    },

    mounted() {
        this.config.zoho_warehouse_id = this.formData.zoho_warehouse_id;
        this.config.zoho_bank_account_id = this.formData.zoho_bank_account_id;
    }
}
</script>
